const COORDINATED_VIEWPORT_MULTIPLIERS = Object.freeze({
  mobile: 1,
  tablet: 0.75,
  desktop: 0.5
});

function getViewportHeight(explicitHeight) {
  const candidate = Number(explicitHeight);
  if (Number.isFinite(candidate) && candidate > 0) {
    return candidate;
  }
  if (typeof window !== 'undefined') {
    const windowHeight = Number(window.innerHeight);
    if (Number.isFinite(windowHeight) && windowHeight > 0) {
      return windowHeight;
    }
  }
  if (typeof document !== 'undefined' && document.documentElement) {
    const documentHeight = Number(document.documentElement.clientHeight);
    if (Number.isFinite(documentHeight) && documentHeight > 0) {
      return documentHeight;
    }
  }
  return 800;
}

function resolveCoordinatedRequestThreshold(options = {}) {
  const legacyThreshold = Number(options.legacyThreshold);
  const normalizedLegacyThreshold = Number.isFinite(legacyThreshold) && legacyThreshold >= 0
    ? legacyThreshold
    : 0;
  if (options.coordinated !== true) {
    return normalizedLegacyThreshold;
  }

  const device = String(options.device || 'desktop').toLowerCase();
  const configuredMultiplier = Number(options.viewportMultiplier);
  const viewportMultiplier = Number.isFinite(configuredMultiplier) && configuredMultiplier > 0
    ? configuredMultiplier
    : (COORDINATED_VIEWPORT_MULTIPLIERS[device]
      || COORDINATED_VIEWPORT_MULTIPLIERS.desktop);
  const configuredMinimum = Number(options.minThreshold);
  const minThreshold = Number.isFinite(configuredMinimum) && configuredMinimum >= 0
    ? configuredMinimum
    : 250;
  const scaledThreshold = Math.max(
    minThreshold,
    Math.round(getViewportHeight(options.viewportHeight) * viewportMultiplier)
  );

  return normalizedLegacyThreshold > 0
    ? Math.min(normalizedLegacyThreshold, scaledThreshold)
    : scaledThreshold;
}

module.exports = {
  COORDINATED_VIEWPORT_MULTIPLIERS,
  getViewportHeight,
  resolveCoordinatedRequestThreshold
};
